'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lib = require('../lib-26f8f706.js');
var definitions = require('../definitions-0c162dc8.js');
var list_index = require('./index.js');
require('tslib');
require('react');
require('../utils-9a8db0ee.js');
require('../env-100217af.js');
require('../style-inject.es-71b52b81.js');

var spacingNormal = {
	value: 1,
	unit: "rem"
};

var Row = lib.variant('Row', list_index.List, {
    direction: definitions.Axis.X,
});
var Column = lib.variant('Column', list_index.List, {
    direction: definitions.Axis.Y,
});
var GridRow = lib.variant('GridRow', Row, {
    equallySizedChildren: true,
    gap: spacingNormal.value,
});
var GridColumn = lib.variant('GridColumn', Column, {
    equallySizedChildren: true,
    gap: spacingNormal.value,
});

exports.Column = Column;
exports.GridColumn = GridColumn;
exports.GridRow = GridRow;
exports.Row = Row;
//# sourceMappingURL=variants.js.map
